/*
  Controla se estamos usando movimantação reduzida
*/
export default (state, reduced=false) => 
	state.Motion.reducedMotion = reduced
	
